import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react';

import type { ApprovalFlowData } from './types.js';

export interface ApprovalFlowContextProps {
  approvalFlowData: ApprovalFlowData | {} | null;
  setApprovalFlowData: Dispatch<SetStateAction<ApprovalFlowData>>;
}

const ApprovalFlowContext = createContext<ApprovalFlowContextProps>({
  approvalFlowData: null,
  setApprovalFlowData: () => ({}),
});

export const ApprovalFlowProvider = ({ children }: { children: ReactNode }) => {
  const [approvalFlowData, setApprovalFlowData] = useState({});

  const contextValue = useMemo(
    () => ({ approvalFlowData, setApprovalFlowData }),
    [approvalFlowData, setApprovalFlowData],
  );

  const AppFlowProvider = ApprovalFlowContext.Provider;

  return <AppFlowProvider value={contextValue}>{children}</AppFlowProvider>;
};
export const useApprovalFlowContext = () => useContext(ApprovalFlowContext);

export default ApprovalFlowContext;
